import React from 'react';

export const Sample = (props) => {
  return (
    <article className='sample'>
      <span>Sample</span>
    </article>
  );
};
